module.exports = __webpack_public_path__ + "img/goal-07.1f32c46b.png";